/**
 * --------------------------------------------------------
 * VDB Framework
 * The Automotive Intelligence Layer for Shopify
 *
 * Version : 1.0.0
 * Release : Foundation
 * Build   : 003
 * Commit  : 003.1
 * Module  : Provider Registry
 * --------------------------------------------------------
 */
(function (window) {
  "use strict";

  const VDB = window.VDB = window.VDB || {};
  const providers = new Map();
  let activeName = null;

  function assertProvider(provider) {
    const methods = ["getMakes", "getModels", "getYears", "getEngines", "resolveVehicle"];
    const missing = methods.filter(function (method) {
      return !provider || typeof provider[method] !== "function";
    });
    if (missing.length) {
      throw new Error("Invalid VDB provider. Missing: " + missing.join(", "));
    }
  }

  VDB.providers = {
    register: function (name, provider) {
      if (!name || typeof name !== "string") throw new Error("Provider name is required.");
      assertProvider(provider);
      providers.set(name, provider);
      return provider;
    },
    use: function (name) {
      if (!providers.has(name)) throw new Error("VDB provider is not registered: " + name);
      activeName = name;
      return providers.get(name);
    },
    get: function (name) {
      return providers.get(name || activeName) || null;
    },
    has: function (name) {
      return providers.has(name);
    },
    active: function () {
      return activeName;
    },
    list: function () {
      return Array.from(providers.keys());
    }
  };
})(window);
